export default function initModals() {
  const modals = {
    activeModal: null,
  };

  const overlay = document.querySelector('.modals-overlay');
  overlay.addEventListener('click', () => {
    if(modals[modals.activeModal]) modals[modals.activeModal].close();
  });

  function toggleOverlay() {
    const overlay = document.querySelector('.modals-overlay');
    if (!overlay.classList.contains('active'))  {
      overlay.classList.add('active');
    } else {
      overlay.classList.remove('active');
    }
  }

  //videoModal
  const videoModal = document.getElementById('videoModal');

  if(videoModal) {
    modals.videoModal = { $el: videoModal };
    modals.videoModal.open = (slide) => {
      if (!slide) return;
      toggleOverlay();
      const videoUrl = slide.getAttribute('data-video') + "?autoplay=1";
      if (videoUrl) {
        document.getElementById('modal-video-frame').src = videoUrl;
        videoModal.style.display = 'flex';
      }
      modals.activeModal = 'videoModal';
    }
    modals.videoModal.close = () => {
      toggleOverlay();
      videoModal.style.display = 'none';
      document.getElementById('modal-video-frame').src = "";
      modals.activeModal = null;
    }

    document.querySelectorAll('.videos__slide').forEach(slide => {
      slide.addEventListener('click', () => modals.videoModal.open(slide));
    });
    videoModal.querySelector('.modal-close').addEventListener('click', () =>  modals.videoModal.close());
  }


  // formModal
  const formModal = document.getElementById('formModal');
  if(formModal) {
    const OPEN_DURATION = 200;
    formModal.style.transform = 'translate(110%, 0)';
    formModal.style.transitionDuration = `${OPEN_DURATION}ms`;

    const openModalBtn = document.querySelector('.js-modal-contacts');
    const closeModalBtn = formModal.querySelector('.modal-close');
    const consultationForm = document.getElementById('consultationForm');

    modals.formModal = { $el: formModal };
    modals.formModal.open = () => {
      toggleOverlay();
      formModal.classList.add('active');
      modals.activeModal = 'formModal';
      setTimeout(() => {
        formModal.style.transform = 'translate(0, 0)'
      }, 0);
    }

    modals.formModal.close = () => {
      toggleOverlay();
      formModal.style.transform = 'translate(110%, 0)'
      modals.activeModal = null;
      setTimeout(() => {
        formModal.classList.remove('active');
      }, OPEN_DURATION);
    }

    modals.formModal.submit = (e) => {
      // обработка формы тут
      e.preventDefault();
      modals.formModal.close();
      consultationForm.reset();
    }

    openModalBtn.addEventListener('click', () => modals.formModal.open());
    closeModalBtn.addEventListener('click', () => modals.formModal.close());
    consultationForm.addEventListener('submit', (e) => modals.formModal.submit(e));

    // Маска для телефона
    const phoneInput = document.querySelector('input[type="tel"]');
    phoneInput?.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      if (value[0] !== '7') value = '7' + value;

      const parts = [
        '+' + value[0],
        value.slice(1, 4) && ' (' + value.slice(1, 4),
        value.slice(4, 7) && ') ' + value.slice(4, 7),
        value.slice(7, 9) && ' ' + value.slice(7, 9),
        value.slice(9, 11) && ' ' + value.slice(9, 11),
      ].filter(Boolean);

      e.target.value = parts.join('');
    });
  }
}

